import styled from 'styled-components'

const TriggerContainer = styled.div`
  height: 100%;
  ${props => props.fullWidth && 'width: 100%'};
`

export default TriggerContainer
